import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CHAT_FEATURE_KEY, ChatEffects, chatReducer } from 'libs/shared/data/stores/chat';

import { USER_FEATURE_KEY, userReducer, UserEffects } from '@offconon/shared/data/stores/user';

@NgModule({
  imports: [
    StoreModule.forFeature(CHAT_FEATURE_KEY, chatReducer),
    StoreModule.forFeature(USER_FEATURE_KEY, userReducer),
    EffectsModule.forFeature([ChatEffects, UserEffects]),
  ],
})
export class ChatStateModule {}
